// Global snackbar utility for use outside React components (e.g., axios interceptors)
let enqueueSnackbarFn = null;

// Track recently shown messages to prevent duplicates
const recentMessages = new Map();
const DUPLICATE_PREVENTION_WINDOW = 2000; // 2 seconds

export const setSnackbarEnqueue = (fn) => {
  enqueueSnackbarFn = fn;
};

// Helper function for components to safely show errors (checks if already displayed)
export const showErrorIfNotDisplayed = (error, enqueueSnackbarFn) => {
  // Check if error was already displayed by axios interceptor
  if (error?.__errorDisplayed) {
    console.log('[SNACKBAR] Error already displayed by interceptor, skipping component display');
    return;
  }
  
  // Use the message from error object
  const message = error?.message || error?.response?.data?.message || 'An error occurred';
  
  // Use showSnackbar which has duplicate prevention
  showSnackbar(message, "error");
};

export const showSnackbar = (message, variant = "error") => {
  // Get stack trace to see who called this
  const stack = new Error().stack;
  const caller = stack?.split('\n')[2]?.trim() || 'unknown';
  
  console.log('[SNACKBAR] showSnackbar called:', {
    message,
    variant,
    caller,
    timestamp: new Date().toISOString()
  });
  console.log('[SNACKBAR] Full stack trace:', stack);

  if (!enqueueSnackbarFn) {
    // Fallback to console if snackbar is not initialized
    console.error("Snackbar not initialized:", message);
    return;
  }

  // Check if this exact message was shown recently
  const now = Date.now();
  const messageKey = `${message}-${variant}`;
  const lastShown = recentMessages.get(messageKey);

  if (lastShown && (now - lastShown) < DUPLICATE_PREVENTION_WINDOW) {
    // Skip duplicate message within the time window
    console.log('[SNACKBAR] DUPLICATE DETECTED - Blocking duplicate message:', {
      message,
      variant,
      lastShown: new Date(lastShown).toISOString(),
      timeSinceLastShown: now - lastShown,
      caller
    });
    return;
  }

  // Show the message and record the time
  console.log('[SNACKBAR] Showing snackbar:', {
    message,
    variant,
    caller
  });
  enqueueSnackbarFn(message, { variant });
  recentMessages.set(messageKey, now);

  // Clean up old entries periodically (keep map size manageable)
  if (recentMessages.size > 100) {
    const cutoff = now - DUPLICATE_PREVENTION_WINDOW;
    for (const [key, timestamp] of recentMessages.entries()) {
      if (timestamp < cutoff) {
        recentMessages.delete(key);
      }
    }
  }
};
